import { render, staticRenderFns } from "./RestaurantPreview.vue?vue&type=template&id=70b9c596&scoped=true&"
import script from "./RestaurantPreview.vue?vue&type=script&lang=js&"
export * from "./RestaurantPreview.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantPreview.vue?vue&type=style&index=0&id=70b9c596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b9c596",
  null
  
)

export default component.exports